import React from 'react';
import { AVATAR_COLOURS, avatarColour, initialsOf } from '../../../../models/SettingsModel';

/**
 * The profile's avatar: initials on a brand swatch, as the prototype draws
 * it. Picking a swatch stages the colour in the form, so Update profile
 * commits it and Cancel walks it back. Photo upload isn't built yet: Upload
 * photo says so, as the prototype's does.
 */
function AvatarPicker({ name, colour, onColour, onShowToast }) {
  const fill = avatarColour(colour);
  return (
    <div className="profile-avatar-wrap">
      <span className="profile-avatar" style={{ background: fill.fill, color: fill.ink }} aria-hidden="true">
        {initialsOf(name)}
      </span>
      <div className="profile-swatches" role="radiogroup" aria-label="Avatar colour">
        {AVATAR_COLOURS.map((c) => (
          <button
            key={c.id}
            type="button"
            role="radio"
            aria-checked={c.id === fill.id}
            aria-label={`Avatar colour ${c.id}`}
            className={`profile-swatch${c.id === fill.id ? ' is-selected' : ''}`}
            style={{ background: c.fill }}
            onClick={() => onColour(c.id)}
          />
        ))}
      </div>
      <p className="profile-or">or upload a photo</p>
      <button
        type="button"
        className="resui-btn resui-btn--tertiary resui-btn--small"
        onClick={() => onShowToast?.('Photo upload is not wired up in this prototype.', 'warn')}
      >
        Upload photo
      </button>
    </div>
  );
}

export default AvatarPicker;
